import { Fragment, useCallback, useEffect, useState } from "react";
import { Button, Grid, TextField } from "@mui/material";

import { StyledStack, ButtonContainer, StyledTitle } from "./editSlides";
import DrawerCM from "components/shared/Drawer";
import Upload from "components/shared/Upload";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import useHttp from "hooks/use-http";

import { validateImg, slideContentSchema } from "validations";

// material icons
import CheckIcon from "@mui/icons-material/Check";

import {
  deleteSlidesImageRequest,
  editSlideImageRequest,
  getSlideImageByIdRequest,
} from "api/requests/slides";
import DeleteModal from "components/shared/Modal/Delete";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import { Delete } from "@mui/icons-material";

function EditSlides() {
  const { slide_img_id } = useParams();
  const navigate = useNavigate();

  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(slideContentSchema),
  });

  // upload image state
  const [slideImage, setSlideImage] = useState({
    url: null,
    isChanged: false,
  });

  // uploaded image handler
  const handleImageChange = (val) => {
    validateImg(val);
    setSlideImage({
      url: val,
      isChanged: true,
    });
  };

  // delete modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  //handle delete modal
  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const handelDelete = async (id) => {
    const res = await request({
      url: deleteSlidesImageRequest,
      values: id,
    });
    if (res) {
      Toast({ type: "success", title: "حذف" });
      navigate("/slides");
    }
    handelShowModal();
  };

  const onSubmit = async (data) => {
    if (!slideImage.url) return Toast({ type: "empty", title: "فیلد عکس " });
    console.log(slideImage);
    const res = await request({
      url: () =>
        editSlideImageRequest(
          {
            ...data,
            id: slide_img_id,
            image: slideImage,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "ویرایش عکس" });
      navigate("/slides");
    }
  };

  const getSlideImageDataById = useCallback(async () => {
    const res = await request({
      url: getSlideImageByIdRequest,
      values: { id: slide_img_id },
    });

    if (res) {
      const data = res.data;
      setSlideImage({ url: data?.image, isWeb: true });
      reset({
        title: data?.title,
        text: data?.text,
        link: data?.link,
        alt: data?.image_details?.alt,
        keyword: data?.keyword,
      });
    }
  }, [request]);

  useEffect(() => {
    getSlideImageDataById();
  }, []);

  return (
    <Fragment>
      <DrawerCM title="ویرایش اسلاید">
        {isUploading ? (
          <ProgressBarCM value={uploadProgress} />
        ) : loading ? (
          <LoadingCM />
        ) : (
          <Grid container my={2} spacing={2}>
            <BackButton />

            <StyledStack>
              <StyledTitle>ویرایش اسلاید </StyledTitle>
              <Grid container my={1} spacing={2}>
                <Grid item md={6} xs={12}>
                  {slideImage.url ? (
                    <Upload
                      isWeb={slideImage.isWeb}
                      isLocal={!slideImage.isWeb}
                      file={slideImage.url}
                      refillable
                      type="add-slide-image"
                      onChange={handleImageChange}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={slideImage.isChanged}
                      file={slideImage.url}
                      refillable
                      type="add-slide-image"
                      onChange={handleImageChange}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="متن"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={6}
                    id="image_text"
                    {...register("text")}
                    error={Boolean(errors.text)}
                    helperText={errors.text?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="عنوان"
                    variant="outlined"
                    fullWidth
                    id="title"
                    {...register("title")}
                    error={Boolean(errors.title)}
                    helperText={errors.title?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="لینک"
                    variant="outlined"
                    fullWidth
                    id="link"
                    {...register("link")}
                    error={Boolean(errors.link)}
                    helperText={errors.link?.message}
                  />
                </Grid>

                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="متن جایگزین"
                    variant="outlined"
                    fullWidth
                    id="alt"
                    {...register("alt")}
                    error={Boolean(errors.alt)}
                    helperText={errors.alt?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="کلمه کلیدی"
                    variant="outlined"
                    fullWidth
                    id="keyword"
                    {...register("keyword")}
                    error={Boolean(errors.keyword)}
                    helperText={errors.keyword?.message}
                  />
                </Grid>
                <ButtonContainer>
                  <Button
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 2 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ویرایش
                  </Button>
                  <Button
                    startIcon={<Delete />}
                    variant="contained"
                    color="error"
                    sx={{ mt: 1 }}
                    onClick={() => handelShowModal()}
                  >
                    حذف
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledStack>
          </Grid>
        )}
      </DrawerCM>
      <DeleteModal
        show={showDeleteModal}
        onClose={handelShowModal}
        onDelete={handelDelete.bind(null, slide_img_id)}
      />
    </Fragment>
  );
}
export default EditSlides;
